import { SelectInput, TextInput } from "@/components/ui/Field";
import { SegmentedControl } from "@/components/ui/SegmentedControl";
import { ansprechpartnerAnredeOptions, type GeschaeftspartnerTyp } from "@/lib/kontakte";
import { switchPartnerart, type PartnerNameForm } from "@/pages/kontakte/partnerart";

export function PrivatpersonBadge() {
  return (
    <span className="shrink-0 rounded-full bg-fill-secondary px-2 py-0.5 text-[11px] font-medium text-label-secondary">
      Privat
    </span>
  );
}

export function PartnerNameFields({
  typ,
  form,
  onChange,
}: {
  typ: GeschaeftspartnerTyp;
  form: PartnerNameForm;
  onChange: (next: PartnerNameForm) => void;
}) {
  const isPerson = typ === "kunde" && form.partnerart === "privatperson";

  return (
    <>
      {typ === "kunde" ? (
        <div className="sm:col-span-2">
          <p className="eh-label mb-2">Art</p>
          <SegmentedControl
            name="Art des Kunden"
            size="md"
            value={form.partnerart}
            onChange={(next) => onChange(switchPartnerart(form, next))}
            options={[
              { value: "firma", label: "Firma" },
              { value: "privatperson", label: "Privatperson" },
            ]}
          />
        </div>
      ) : null}
      {isPerson ? (
        <>
          <SelectInput
            label="Anrede"
            value={form.anrede}
            onChange={(e) => onChange({ ...form, anrede: e.target.value })}
            hint="Steht auf Belegen vor dem Namen, z. B. Frau Simone Singer."
            className="sm:col-span-2"
          >
            <option value="">—</option>
            {ansprechpartnerAnredeOptions(form.anrede).map((opt) => (
              <option key={opt} value={opt}>
                {opt}
              </option>
            ))}
          </SelectInput>
          <TextInput
            label="Vorname *"
            value={form.vorname}
            onChange={(e) => onChange({ ...form, vorname: e.target.value })}
          />
          <TextInput
            label="Nachname *"
            value={form.nachname}
            onChange={(e) => onChange({ ...form, nachname: e.target.value })}
          />
        </>
      ) : (
        <TextInput
          label="Firmenname *"
          value={form.firmenname}
          onChange={(e) => onChange({ ...form, firmenname: e.target.value })}
          className="sm:col-span-2"
        />
      )}
    </>
  );
}
